<template>
  <div class="row content form">
    <div class="row form-input" v-if="isLoadingProgram">
      <div class="col-sm-12 text-center">
        <div class="spinner-grow spinner-grow-sm" role="status"></div>
      </div>
    </div>
    <div class="row gx-2 form-input" v-if="!isLoadingProgram && program">
      <div class="col-sm-12 mb-1">
        <label for="basic-url">{{ terms?.Program }} Type (Optional)</label>
        <br />
        <div class="row">
          <div class="col-xs-12 col-sm-3" v-for="programType in filteredProgramTypes" :key="programType.programTypeId">
            <div class="btn-group-toggle mr-2" style="width: 200px; display: inline" data-toggle="buttons">
              <label class="btn btn-secondary bg-light text-secondary active">
                <input type="checkbox" @change="validateDeliverers" v-model="programType.selected" />
                <span class="checklabel">{{
                  props.programCategoryId == 1
                    ? programType.programTypeName.replace("Female", "Girls")
                    : props.programCategoryId == 2
                      ? programType.programTypeName.replace("Female", "Women")
                      : programType.programTypeName
                }}</span>
              </label>
            </div>
            <label class="checklabel m-0 mb-2" v-if="programType.selected">
              {{ programType.programTypeName == 'Female only' ? '' : programType.programTypeDescription }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-2">
        <div class="row form-input gx-2">
          <div v-if="props.programCategoryId == 1" class="col-xs-12 col-sm-6">
            <label for="term">Term {{ setting?.isTermFieldRequired ? '*' : '' }}</label>
            <div>
              <select class="form-select" v-model="program.programTermId"
                :disabled="isLegacyProgramTerm(program.programTermId) && !isNew" id="term" @change="v$.programTermId.$touch">
                <option value="" selected>Select Term</option>
                <option v-for="(term, index) in programTermsWithLegacy" :value="term.programTermId" :key="index">
                  {{ term.programTermName }}
                </option>
              </select>
              <span class="error" v-if="v$.programTermId.$dirty && v$.programTermId.$error">
                {{ "Term is required" }}
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label for="venue">Venue *</label>
            <div>
              <select class="form-select" v-model="program.venueId" id="venue" @change="v$.venueId.$touch">
                <option selected v-for="venue in allVenues" :disabled="isLoadingAllVenues" :value="venue.key">
                  {{ venue.value }}
                </option>
              </select>
              <span class="error" v-if="v$.venueId.$error">
                {{ "Venue is required" }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 mb-3">
        <label for="basic-url">{{ terms?.Program }} Name (min 2 characters and max 200 characters) *</label>
        <div class="input-group">
          <input type="text" class="form-control" :placeholder="`${terms?.Program} Name`" aria-label="Program Name"
            v-model="program.programName" maxlength="200" @input="v$.programName.$touch" />
          <span class="error" v-if="v$.programName.$dirty && v$.programName.$error">
            {{ `${terms?.Program} name is required` }}
          </span>
        </div>
      </div>
      <div class="col-xs-12 mb-3">
        <label for="basic-url">{{ terms?.Program }} Description (min 2 characters and max 1000 characters) *</label>
        <div class="input-group">
          <textarea class="form-control"
            :placeholder="`Use this section to describe your ${terms?.Program.toLowerCase()}`"
            aria-label="Use this section to describe your program" v-model="program.programDescription" maxlength="1000"
            rows="5" @input="v$.programDescription.$touch" />
          <span class="error" v-if="v$.programDescription.$error">
            {{ `${terms?.Program} description is required` }}
          </span>
        </div>
      </div>
      <div class="col-sm-12 mb-3">
        <label for="basic-url">Deliverer *</label>
        <div class="row form-input mb-2 gx-2" v-for="(delivererItem, index) in program.deliverers" :key="index">
          <div class="col-sm-4 pt-1">
            <label for="basic-url">Name *</label>
            <div class="input-group" v-if="!setting?.showProgramDelivererSearch">
              <input class="form-control" placeholder="First Name & Surname" aria-label="First Name & Surname"
                maxlength="300" v-model="delivererItem.name" @blur="() => isDelivererExists(delivererItem)" />
            </div>
            <div class="input-group" v-else>
              <input type="text" @input="($event) => searchDeliverer(delivererItem, $event)" class="form-control"
                @blur="() => isDelivererExists(delivererItem)" v-model="delivererItem.name" autocomplete="off"
                placeholder="Type to search deliverer" />
              <div class="col-sm-12" v-if="delivererItem.isSearching">
                <div class="spinner-grow spinner-grow-sm" role="status"></div>
              </div>
              <div v-if="delivererItem.showSearchContainer" class="searchContainer">
                <span @click="() => onSelect(delivererItem, item)" v-for="item in delivererItem.searchList"
                  class="searchItem">
                  {{ item.firstName }} {{ item.lastName }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-4 pt-1">
            <label for="basic-url">Qualification *</label>
            <div class="input-group">
              <select class="form-select" v-model="delivererItem.delivererTypeId" id="delivererType"
                @change="isDelivererExists(delivererItem)">
                <option v-for="(delivererType, index) in delivererTypes" :value="delivererType.delivererTypeId"
                  :key="index">
                  {{ delivererType.description }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4 pt-1">
            <label for="basic-url">{{
              delivererItem.delivererTypeId == DelivererTypeEnum.CommunityInstructor
                ? "Email *"
                : "Membership ID"
            }}</label>
            <div class="input-group">
              <input class="form-control" placeholder="Input Email" aria-label="Input Email" maxlength="300"
                :disabled="setting?.showProgramDelivererSearch" v-model="delivererItem.email"
                @blur="() => isDelivererExists(delivererItem)" v-if="!isMembershipIdRequired(delivererItem)" />
              <input v-else class="form-control" placeholder="Input Membership ID" aria-label="Input Membership ID"
                maxlength="300" v-model="delivererItem.membershipId" @blur="() => isDelivererExists(delivererItem)" />
              <button class="btn-delete" @click="() => removeDeliverer(index)"
                v-if="program.deliverers && program.deliverers.length > 1">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>

          <div class="col-sm-12" v-if="isLoadingValidate">
            <div class="spinner-grow spinner-grow-sm" role="status"></div>
          </div>

          <div class="col-sm-12" v-if="delivererValidationStarted && !isLoadingValidate && !delivererItem.isValid
          ">
            <label class="text-danger">Incorrect input, please enter a valid deliverer</label>
          </div>
          <div class="col-sm-12" v-if="delivererValidationStarted && !delivererItem.isValidEmail">
            <label class="text-danger">Email is invalid</label>
          </div>
        </div>
        <div class="col-sm-12 pt-2" v-if="program.deliverers && program.deliverers.length <= 5">
          <button class="btn-edit btn-lg" @click="addDeliverer">
            <i class="bi bi-plus-square-fill"></i>
            Add Deliverer
          </button>
        </div>
        <div class="mt-3">
          <label>{{ setting?.programCreationDelivererInvolveText }}</label>
          <br />
          <label class="text-danger" v-if="hasDuplicateDeliverer">You have entereed duplicate deliverer</label>
        </div>
      </div>
      <div class="col-sm-12 mb-4 mt-4">
        <hr class="hr" />
      </div>
      <div class="col-sm-12 mb-3">
        <h5>Session Dates and Times</h5>
      </div>
      <div class="col-sm-12 mb-3">
        <div class="row form-input gx-2">
          <div class="col-sm-6">
            <label for="basic-url">Start Date</label>
            <div>
              <VueDatePicker v-model="program.startDate" format="dd MMM yyyy (EEE)" :clearable="true"
                :enable-time-picker="false" auto-apply placeholder="DD Mon YYYY (Day)" @update:model-value="() => {
                  showGenerateTimeTable = true;
                  validationStarted = true;
                }
                " />
            </div>
          </div>
          <div class="col-sm-6">
            <label for="basic-url">End Date</label>
            <div>
              <VueDatePicker v-model="program.endDate" format="dd MMM yyyy (EEE)" :clearable="true"
                :enable-time-picker="false" auto-apply placeholder="DD Mon YYYY (Day)" @update:model-value="() => {
                  showGenerateTimeTable = true;
                  validationStarted = true;
                }
                " />
            </div>
          </div>
          <div class="col-sm-12">
            <label class="text-danger" v-if="!isValidSessionDate">The start date cannot be later than the end
              date.</label>
            <label class="text-danger" v-if="!hasInputSessionDate">Start date and end date must have a value</label>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-3">
        <label for="basic-url">Days of the week</label>
        <div class="input-group">
          <div class="form-group mr-1">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isMonday" />
              Monday
            </label>
          </div>
          <div class="form-group mr-1">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isTuesday" />
              Tuesday
            </label>
          </div>
          <div class="form-group mr-1">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isWednesday" />
              Wednesday
            </label>
          </div>
          <div class="form-group mr-1">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isThursday" />
              Thursday
            </label>
          </div>
          <div class="form-group mr-1">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isFriday" />
              Friday
            </label>
          </div>
          <div class="form-group mr-1">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isSaturday" />
              Saturday
            </label>
          </div>
          <div class="form-group">
            <label class="btn btn-secondary bg-light text-secondary active">
              <input type="checkbox" @change="showGenerateTimeTable = true" v-model="program.isSunday" />
              Sunday
            </label>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-3">
        <div class="row form-input gx-2">
          <div class="col-sm-6">
            <label for="basic-url">Start Time</label>
            <div class="input-group">
              <VueDatePicker v-model="program.timeFrom" :clearable="true" :is-24="false" time-picker auto-apply
                placeholder="HH:MM AM/PM" @update:model-value="onTimeChanged" />
            </div>
          </div>
          <div class="col-sm-6">
            <label for="basic-url">End Time</label>
            <div class="input-group">
              <VueDatePicker v-model="program.timeTo" :clearable="true" time-picker :is-24="false" auto-apply
                placeholder="HH:MM AM/PM" @update:model-value="onTimeChanged" />
            </div>
          </div>
          <div class="col-sm-12">
            <label class="text-danger" v-if="!hasInputSessionTime">Start time and end time must have a value</label>
            <label class="text-danger" v-if="!isValidSessionTime">The start time cannot be later than the end time.</label>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-3 pt-3">
        <div class="row form-input">
          <div class="col-sm-6">
            <label for="basic-url">Time Table</label>
          </div>
          <div class="col-sm-6 text-right">
            <button class="btn btn-primary" :disabled="!isValidSessionTime || !isValidSessionDate"
              @click="generateSessions">
              <i class="bi bi-arrow-clockwise"></i>
              Regenerate the timetable
            </button>
            <div v-if="showGenerateTimeTable" class="warning">
              Please click the "Regenerate the timetable" button
            </div>
          </div>
        </div>
        <div class="table-wrapper">
          <EasyDataTable v-if="program && program.programSessionsDisplay.length > 0"
            v-model:server-options="serverOptions" table-class-name="datatable" :headers="programSessionHeaders"
            :items="items" :server-items-length="program.programSessionsDisplay?.length" hide-footer must-sort
            :alternating="true" class="data-table">
            <template #item-date="item">
              {{ item.date }}
            </template>
            <template #item-time="item">
              {{ item.time }}
            </template>
            <template #item-buttons="item">
              <div class="icon-col">
                <button v-b-modal="'my-modal'" class="btn-delete" @click="() => deleteSession(item)">
                  <i class="bi bi-trash ms-1"></i>
                </button>
              </div>
            </template>
          </EasyDataTable>
        </div>
        <div class="mt-3" v-if="program.programSessionsDisplay?.length">
          <label>Total number of sessions: {{ program.programSessionsDisplay?.length }}</label>
        </div>

        <div class="mt-3" v-if="!isValidProgramSession && validationStarted">
          <label class="text-danger">Unable to continue please add at least one program session.</label>
        </div>
      </div>
      <div class="col-sm-12 mb-4 mt-4">
        <hr class="hr" />
      </div>
      <div class="col-sm-12 mb-3">
        <h5>Registration</h5>
      </div>
      <div class="col-sm-12 mb-5">
        <div class="row form-input gx-2">
          <div class="col-sm-6">
            <label for="basic-url">Maximum number of participants *</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Maximum number of participants"
                aria-label="Maximum number of participants" v-model="program.participantMaxCount" maxlength="7"
                @update:model-value="v$.participantMaxCount.$touch" />
              <span class="error" v-if="v$.participantMaxCount.$error">
                <span v-for="error in v$.participantMaxCount.$errors">
                  {{ error.$message }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-4">
            <label for="basic-url">Registration cut-off date*</label>
            <div>
              <VueDatePicker v-model="program.registrationCutOffDateUTC" format="dd MMM yyyy (EEE)" :clearable="true"
                :enable-time-picker="false" auto-apply placeholder="DD Mon YYYY (Day)"
                @change="v$.registrationCutOffDateUTC.$touch"/>
              <span class="error" v-if="v$.registrationCutOffDateUTC.$error">
                {{ "Registration CutOff Date is required" }}
              </span>
            </div>
            <div class="col-12 mb-3">
              <div class="mt-3" v-if="!isValidStartAndCutOffDate">
                <label class="text-danger">Cut-off date must not be later than the {{ terms?.Program.toLowerCase() }}
                  end
                  date.</label>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="aest">11:59PM {{ setting.timeZoneAbreviation }}</div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-3">
        <label>Priority Registration</label>
        <p>
          Priority registration allows {{ terms?.ProgramPlural.toLowerCase() }} to be hidden from public view. It will
          generate a unique URL (link) to provide to participants for registration. The
          {{ terms?.Program.toLowerCase() }} will remain hidden from public view until the date provided below, at
          which point the {{ terms?.Program.toLowerCase() }} will become public as normal.
        </p>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" v-model="program.hasPriorityRegistration" role="switch"
            id="hasPriorityRegistration" />
          <label class="form-check-label" for="hasPriorityRegistration">Enable priority registration</label>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4 mb-3" v-if="program.hasPriorityRegistration">
        <label for="basic-url">Priority registration end date *</label>
        <div class="input-group">
          <VueDatePicker v-model="program.priorityRegistrationExpiryDate" format="dd MMM yyyy (EEE)" :clearable="true"
            :enable-time-picker="false" auto-apply placeholder="DD Mon YYYY (Day)" />
          <span class="error" v-if="program.hasPriorityRegistration && !program.priorityRegistrationExpiryDate
          ">
            {{ "Priority registration end date is required" }}
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4 mb-3" v-if="program.hasPriorityRegistration">
        <div class="aest">11:59PM {{ setting.timeZoneAbreviation }}</div>
      </div>
      <div class="col-12 mb-3" v-if="program.hasPriorityRegistration">
        <div class="mt-3" v-if="!isValidPriorityRegistration">
          <label class="text-danger">Priority registration end date must be on or before the registration cut-off
            date.</label>
        </div>
      </div>
      <div class="col-sm-12 mb-4 mt-4">
        <hr class="hr" />
      </div>
      <div class="col-sm-12 mb-3">
        <h5>Cost</h5>
      </div>
      <div class="col-sm-12 mb-5">
        <ProgramPriceEstimate :currency="currency" :estimate="firstParticipantPriceEstimate"
          :is-active="showProgramPriceEstimate">
          <template #cost>
            <div class="d-flex align-items-center gap-1">
              <label for="programCostFirstParticipant">Total {{ terms?.Program.toLowerCase() }} cost *</label>
              <InfoTooltip v-if="showProgramPriceEstimate" :text="programPriceTooltip" />
            </div>
            <div class="input-group">
              <span class="input-group-text">{{ currency }}</span>
              <input type="text" class="form-control" placeholder="Enter amount" aria-label="cost"
                v-model="program.programCostFirstParticipant" id="programCostFirstParticipant" maxlength="7"
                @update:model-value="v$.programCostFirstParticipant.$touch" />
              <span class="error" v-for="error in v$.programCostFirstParticipant?.$errors">
                {{ error.$message }}
              </span>
            </div>
            <p class="mb-0 mt-1 small text-muted">
              {{ t("Phrases.Participation.ProgramPriceEstimate.AmountShownDuringRegistration") }}
            </p>
          </template>
        </ProgramPriceEstimate>
      </div>
      <div class="col-sm-12 mb-3"
        v-if="props.programCategoryId == 1 && setting.showMultipleDiscountParticipationProgram">
        <label>Multiple participant discount</label>
        <p>
          If a guardian / parent registers more than one participant at a time, a
          discounted price is applied for the subsequent participants.
        </p>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" v-model="program.enabledDiscountForMultipleParticipants"
            role="switch" id="enabledDiscountForMultipleParticipants" />
          <label class="form-check-label" for="enabledDiscountForMultipleParticipants">Enable discount for multiple
            participants</label>
        </div>
      </div>
      <div class="col-sm-12 mb-5"
        v-if="program.enabledDiscountForMultipleParticipants && setting.showMultipleDiscountParticipationProgram">
        <ProgramPriceEstimate :currency="currency" :estimate="subsequentParticipantPriceEstimate"
          :is-active="showProgramPriceEstimate">
          <template #cost>
            <label for="programCostSubsequentParticipant">Discounted cost for subsequent participants</label>
            <div class="input-group flex-nowrap">
              <span class="input-group-text">{{ currency }}</span>
              <input type="text" id="programCostSubsequentParticipant" class="form-control" placeholder="Enter amount"
                aria-label="Enter amount" maxlength="7"
                @update:model-value="v$.programCostSubsequentParticipant.$touch"
                v-model="program.programCostSubsequentParticipant" />
            </div>
            <div class="error" v-if="program.enabledDiscountForMultipleParticipants">
              <span class="error" v-for="error in v$.programCostSubsequentParticipant?.$errors">
                {{ error.$message }}
              </span>
            </div>
            <p class="mb-0 mt-1 small text-muted">
              {{ t("Phrases.Participation.ProgramPriceEstimate.AmountShownDuringRegistration") }}
            </p>
          </template>
        </ProgramPriceEstimate>
      </div>
      <div class="col-sm-12 mb-3" v-if="programPriceEstimateError">
        <div class="alert alert-warning mb-0" role="alert">
          {{ t("Phrases.Participation.ProgramPriceEstimate.Unavailable", {
            program: terms?.Program.toLowerCase()
          }) }}
        </div>
      </div>
      <div class="col-sm-12 mb-3" v-if="setting.showProrataInParticipationProgram">
        <label>Pro rata</label>
      </div>
      <div class="col-sm-12 mb-3" v-if="setting.showProrataInParticipationProgram">
        <p>
          If enabled, the participant can register into a {{ terms?.Program.toLowerCase() }} that has already
          commenced and pay only for the future scheduled sessions. This cost will be
          automatically generated.
        </p>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" v-model="program.isProRata" role="switch" id="isProRata" />
          <label class="form-check-label" for="isProRata">Accept pro-rata payments</label>
        </div>
      </div>
      <div class="col-sm-12 mb-3 text-right">
        <button class="btn btn-primary" :disabled="isSavingProgram || showGenerateTimeTable" @click="saveProgramData">
          {{ isNew ? "Create" : "Update" }} {{ terms?.Program }}
        </button>
        <button class="btn btn-secondary" @click="back">Cancel</button>
      </div>
    </div>
  </div>
  <Notification ref="saveNotificationMessage" colorScheme="text-bg-success">
    <template #body><i class="bi bi-check-circle"></i> Saved Successfully</template>
  </Notification>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { onMounted, onUnmounted, ref, reactive, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useProgramTermStore } from "@/stores/terms-store";
import { useAuthStore } from "@/stores/auth-store";
import type { IDelivererVm, IProgramPriceEstimate, IProgramVm } from "@/types";
import moment from "moment";
import type { Item, ServerOptions } from "vue3-easy-data-table";
import type { IProgramSessionVm } from "@/types/IProgramSessionVm";
import { nanoid } from "nanoid";
import { useDelivererTypesStore } from "@/stores/deliverer-types-store";
import { useProgramTypeStore } from "@/stores/program-type-store";
import { useDelivererStore } from "@/stores/deliverer-store";
import { useProgramStore } from "@/stores/program-store";
import type { IProgramDelivererVm } from "@/types/IProgramDelivererVm";
import {
  hasDuplicates,
  isEmail,
  enumerateDaysBetweenDates,
  formatMomentTime,
} from "@/tools/utils";
import { DelivererTypeEnum } from "@/enums/delivererTypeEnum";
import { required, minLength, requiredIf, helpers, numeric } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Notification from "@/components/common/Notification.vue";
import InfoTooltip from "@/components/common/InfoTooltip.vue";
import ProgramPriceEstimate from "@/components/ProgramPriceEstimate.vue";
import router from "@/router";
import { ProgramTypeEnum } from "@/enums/programTypeEnum";
import { useVenueStore } from "@/stores/venue-store";
import { useRoute } from "vue-router";
import { useSettingStore } from "@/stores/setting-store";
import { useTermsStore } from "@/stores/language-terms";
import debounce from "lodash/debounce"
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

const authStore = useAuthStore();

const route = useRoute();
const { isLoadingAllVenues, allVenues } = storeToRefs(useVenueStore());
const { loadDelivererTypes } = useDelivererTypesStore();
const { loadProgramTypes } = useProgramTypeStore();
const { isClubhouseUser, clubId, isVirtualClub } = storeToRefs(authStore);

const { saveProgram, getNewProgramPriceEstimate } = useProgramStore();
const { validateDeliverer, validateDelivererByMembershipId, getDeliverers } = useDelivererStore();
const { deliverers } = storeToRefs(useDelivererStore())
const { isLoadingValidate } = storeToRefs(useDelivererStore());
const { delivererTypes } = storeToRefs(useDelivererTypesStore());
const { programTypes } = storeToRefs(useProgramTypeStore());
const { isLoadingProgram, isSavingProgram } = storeToRefs(useProgramStore());
const { getParticipationVenues } = useVenueStore();
const { setting } = storeToRefs(useSettingStore());
const { terms } = storeToRefs(useTermsStore());
const { t } = useI18n();
const programPriceTooltip = computed(() => t("Phrases.Participation.ProgramPriceEstimate.ProgramPriceTooltip"));

// Filter program types based on active category's programTypeIds
const filteredProgramTypes = computed(() => {
  if (!props.activeCategory?.programTypeIds || !programTypes.value) {
    return Array.isArray(programTypes.value) ? programTypes.value : [];
  }
  return programTypes.value.filter(programType => 
    props.activeCategory.programTypeIds.includes(programType.programTypeId)
  );
});

const searchList = ref<Array<IDelivererVm>>()
let saveNotificationMessage = ref<any | null>(null);

defineOptions({
  inheritAttrs: false,
});

const props = defineProps([
  "programCategoryId",
  "activeCategory",
  "programUID",
  "isDuplicate",
  "programData",
  "isValidProgram",
  "currency"
]);

const items = ref<Item[]>();
const validationStarted = ref(false);
const delivererValidationStarted = ref(false);
const firstParticipantPriceEstimate = ref<IProgramPriceEstimate | null>(null);
const subsequentParticipantPriceEstimate = ref<IProgramPriceEstimate | null>(null);
const programPriceEstimateError = ref(false);
let priceEstimateRequestId = 0;

const programSessionHeaders = [
  { text: "Session Date", value: "date", sortable: false },
  { text: "Session Time", value: "time", sortable: false },
  { text: "", value: "buttons", width: 110 },
];

const serverOptions = ref<ServerOptions>({
  page: 1,
  rowsPerPage: 10,
  sortBy: "dateCreated",
  sortType: "asc",
});

const searchDelivererOptions = ref<ServerOptions>({
  page: 1,
  rowsPerPage: 100,
  sortBy: "dateCreated",
  sortType: "asc",
});

const generateTempId = computed(() => {
  return `${new Date().getUTCMilliseconds()}${new Date().getMinutes()}${new Date().getSeconds()}`
})

const registrationCutOffDateLocal = computed({
  get() {
    if (!program.registrationCutOffDateUTC || !setting.value.localTimeZone) return null;

    // Convert UTC to the local timezone
    const utcDate = new Date(program.registrationCutOffDateUTC);
    return utcToZonedTime(utcDate, setting.value.localTimeZone);
  },
  set(value) {
    program.registrationCutOffDateUTC = convertToUTC(value)
  }
})

const { loadProgramTerms } = useProgramTermStore();
const { programTerms } = storeToRefs(useProgramTermStore());
let program = reactive({
  deliverers: [
    {
      tempId: generateTempId.value,
      email: "",
      name: "",
      delivererTypeId: 1,
      isValidEmail: false,
      isValid: false,
    } as IProgramDelivererVm,
  ],
  programCategoryId: props.programCategoryId,
  programSessionsDisplay: [],
  programSessions: [],
  programTypesIds: [],
  venueId: null,
  programTermId: null,
  programName: "",
  programDescription: "",
  startDate: null,
  endDate: null,
  isMonday: false,
  isTuesday: false,
  isWednesday: false,
  isThursday: false,
  isFriday: false,
  isSaturday: false,
  isSunday: false,
  isProRata: false,
  timeTo: null,
  timeFrom: null,
  participantMaxCount: null,
  programUID: null,
  registrationCutOffDateUTC: null,
  programCostFirstParticipant: null,
  createdByClubId: null
} as IProgramVm);

const requiredNameLength = ref(2);
const showGenerateTimeTable = ref(false);

const rule = computed(() => ({
  programName: {
    required,
    minLength: minLength(requiredNameLength.value),
    $autoDirty: false,
  },
  programDescription: { required, minLength: minLength(requiredNameLength.value) },
  programTermId: {
    required: requiredIf(() => {
      return props.programCategoryId === 1 && setting.value.isTermFieldRequired;
    }),
  },
  venueId: { required },
  participantMaxCount: {
    required: helpers.withMessage('Maximum number of participants is required', required),
    numeric: helpers.withMessage('Enter a valid number', numeric)
  },
  registrationCutOffDateUTC: { required },
  programCostFirstParticipant: {
    required: helpers.withMessage("Cost is required", required),
    numeric: helpers.withMessage('Enter a valid amount', numeric)
  },
  programCostSubsequentParticipant: program.enabledDiscountForMultipleParticipants ? {
    required: helpers.withMessage("Cost is required", required),
    numeric: helpers.withMessage('Enter a valid amount', numeric)
  } : {},
}));

const v$ = useVuelidate(rule, program as any);

const searchDeliverer = debounce(async (data: IProgramDelivererVm, $event) => {
  if ($event.target.value.length >= 3) {
    data.isSearching = true
    await getDeliverers($event.target.value,
      '',
      searchDelivererOptions.value.page,
      searchDelivererOptions.value.rowsPerPage,
      searchDelivererOptions.value.sortBy,
      searchDelivererOptions.value.sortType
    )
    data.isSearching = false
    data.searchList = deliverers.value
    data.showSearchContainer = data.searchList.length > 0
  } else {
    data.showSearchContainer = false
  }
}, 500);

const onSelect = (selectedDeliver, item) => {
  if (program.deliverers) {
    const index = program.deliverers?.findIndex(x => x.tempId == selectedDeliver.tempId || x.memberUID == selectedDeliver.memberUID);
    if (index > -1) {
      program.deliverers[index].showSearchContainer = false
      program.deliverers[index].delivererTypeId = item.delivererTypeId
      program.deliverers[index].email = item.email
      program.deliverers[index].memberUID = item.memberUID
      program.deliverers[index].name = `${item.firstName} ${item.lastName}`;
    }
  }
}

watch(allVenues, (value) => {
  if (value && value.length == 1) {
    program.venueId = parseInt(allVenues.value[0].key);
  }
});

onMounted(async () => {
  await loadProgramTerms();
  await loadDelivererTypes();
  await loadProgramTypes();
  await getParticipationVenues();

  if (filteredProgramTypes.value) {
    filteredProgramTypes.value.forEach((element) => {
      element.selected = false;
    });
  }

  if (props.programData) {
    program = Object.assign(program, props.programData);
    
    // Reformat session dates to include day abbreviation
    if (program.programSessionsDisplay && program.programSessionsDisplay.length > 0) {
      program.programSessionsDisplay = program.programSessionsDisplay.map((session: any) => {
        return {
          ...session,
          date: moment(session.sessionDate).format("DD MMM YYYY (ddd)")
        };
      });
    }
    
    items.value = program.programSessionsDisplay;

    if (filteredProgramTypes.value) {
      program.programTypesIds?.forEach((x) => {
        const target = filteredProgramTypes.value.find((p) => p.programTypeId == x);
        if (target) {
          target.selected = true;
        }
      });
    }
  } else {
    items.value = program.programSessionsDisplay;
  }

  if (isDuplicate.value && program) {
    program.programUID = null;
  }

  if (program.programCostSubsequentParticipant) {
    program.enabledDiscountForMultipleParticipants = true;
  }
  if ((program.programUID || isDuplicate.value) && props.programCategoryId == props.programData.programCategoryId) {
    validateDeliverers();
  }
});

const isNew = computed(() => {
  return !(program && program.programUID);
});

const showProgramPriceEstimate = computed(() => {
  return setting.value.isProcessingFeeRemovalActive
    && props.programCategoryId == props.activeCategory?.id;
});

const parsePositivePrice = (value: number | string | null | undefined) => {
  const price = Number(value);
  return Number.isFinite(price) && price > 0 ? price : null;
};

const refreshProgramPriceEstimates = async () => {
  const requestId = ++priceEstimateRequestId;
  const firstParticipantPrice = parsePositivePrice(program.programCostFirstParticipant);
  const subsequentParticipantPrice =
    program.enabledDiscountForMultipleParticipants
      ? parsePositivePrice(program.programCostSubsequentParticipant)
      : null;

  if (!showProgramPriceEstimate.value || (firstParticipantPrice === null && subsequentParticipantPrice === null)) {
    firstParticipantPriceEstimate.value = null;
    subsequentParticipantPriceEstimate.value = null;
    programPriceEstimateError.value = false;
    return;
  }

  try {
    const [firstResult, subsequentResult] = await Promise.allSettled([
      firstParticipantPrice !== null
        ? getNewProgramPriceEstimate(firstParticipantPrice)
        : null,
      subsequentParticipantPrice !== null
        ? getNewProgramPriceEstimate(subsequentParticipantPrice)
        : null,
    ]);

    if (requestId !== priceEstimateRequestId) {
      return;
    }

    firstParticipantPriceEstimate.value = firstResult.status === "fulfilled" ? firstResult.value : null;
    subsequentParticipantPriceEstimate.value = subsequentResult.status === "fulfilled" ? subsequentResult.value : null;
    programPriceEstimateError.value = firstResult.status === "rejected" || subsequentResult.status === "rejected";
  } catch (error) {
    if (requestId !== priceEstimateRequestId) {
      return;
    }

    console.error("Unable to calculate the programme price estimate.", error);
    firstParticipantPriceEstimate.value = null;
    subsequentParticipantPriceEstimate.value = null;
    programPriceEstimateError.value = true;
  }
};

const debouncedRefreshProgramPriceEstimates = debounce(refreshProgramPriceEstimates, 250);

watch(
  () => [
    program.programCostFirstParticipant,
    program.programCostSubsequentParticipant,
    program.enabledDiscountForMultipleParticipants,
    showProgramPriceEstimate.value,
  ],
  () => debouncedRefreshProgramPriceEstimates(),
  { immediate: true }
);

onUnmounted(() => {
  priceEstimateRequestId++;
  debouncedRefreshProgramPriceEstimates.cancel();
});

const isDuplicate = computed(() => {
  return props.isDuplicate;
});

const isSameOrBeforeDateOnly = (date1: string, date2: string) => {
  return moment(date1).isSameOrBefore(moment(date2), 'day');
};

const hasDuplicateDeliverer = computed(() => {
  if (program && program.deliverers && program.deliverers.length == 0) {
    return false;
  }

  var toCompare = program.deliverers?.map(
    (x: any) => `${x.name}-${x.email}-${x.delivererTypeId}`
  );
  return hasDuplicates(toCompare);
});

const isValidProgramSession = computed(() => {
  if (program && program.startDate && program.programSessionsDisplay?.length == 0) {
    return false;
  }
  return true;
});

const hasInputSessionDate = computed(() => {
  if (!validationStarted.value) {
    return true;
  }

  return program && program.endDate && program.startDate;
});

const isValidSessionDate = computed(() => {
  if (
    program &&
    program.endDate &&
    program.startDate &&
    moment(program.startDate) > moment(program.endDate)
  ) {
    return false;
  }
  return true;
});

const onTimeChanged = () => {
  showGenerateTimeTable.value = true;
  validationStarted.value = true;
};

const hasInputSessionTime = computed(() => {
  if (!validationStarted.value) {
    return true;
  }

  return !!(program && program.timeFrom && program.timeTo);
});

const isValidSessionTime = computed(() => {
  if (!program || !program.timeFrom || !program.timeTo) {
    return true;
  }

  const minutes = moment.duration(moment(program.timeTo).diff(program.timeFrom)).asMinutes();
  return minutes >= 1;
});

const isInValid = computed(() => {
  const isValid = v$.value.$errors.length == 0;

  let isValidRegistration =
    program &&
    program.hasPriorityRegistration &&
    program.priorityRegistrationExpiryDate != undefined;
  if (program && program.hasPriorityRegistration) {
    isValidRegistration = program.priorityRegistrationExpiryDate != undefined;
  } else {
    isValidRegistration = true;
  }

  let isValidDiscount = true;
  if (
    program.enabledDiscountForMultipleParticipants &&
    !program.programCostSubsequentParticipant
  ) {
    isValidDiscount = false;
  }

  let hasValidDeliverers = program.deliverers && program.deliverers.length > 0;

  return (
    !isValid ||
    !isValidProgramSession.value ||
    !isValidSessionDate.value ||
    !hasInputSessionDate.value ||
    !isValidSessionTime.value ||
    !hasInputSessionTime.value ||
    !hasValidDeliverers ||
    !isValidStartAndCutOffDate.value ||
    !isValidDiscount ||
    !isValidRegistration ||
    !isValidPriorityRegistration.value
  );
});

const isValidStartAndCutOffDate = computed(() => {
  if (program.registrationCutOffDateUTC) {
    return isSameOrBeforeDateOnly(program.registrationCutOffDateUTC, program.endDate as string);
  }
  return true;
});

const isValidPriorityRegistration = computed(() => {
  const isValidRegistration =
    program && program.hasPriorityRegistration && program.priorityRegistrationExpiryDate;

  if (isValidRegistration && program.registrationCutOffDateUTC) {
    return isSameOrBeforeDateOnly(program.priorityRegistrationExpiryDate as string, program.registrationCutOffDateUTC);
  }
  return true;
});

const isMembershipIdRequired = (deliverer: IProgramDelivererVm) => {
  return deliverer.delivererTypeId != DelivererTypeEnum.CommunityInstructor;
};

const deleteSession = (item: any) => {
  const index = program.programSessionsDisplay.findIndex((x: any) => x.id == item.id);
  if (index > -1) {
    program.programSessionsDisplay?.splice(index, 1);
  }
};

const generateSessions = () => {
  validationStarted.value = true;
  if (
    !isValidSessionTime.value ||
    !isValidSessionDate.value ||
    !hasInputSessionTime.value ||
    !hasInputSessionDate.value
  ) {
    return;
  }

  program.programSessionsDisplay = Array<IProgramSessionVm>();

  const excludedDays = Array<number>();
  if (!program.isMonday) {
    excludedDays.push(1);
  }

  if (!program.isTuesday) {
    excludedDays.push(2);
  }

  if (!program.isWednesday) {
    excludedDays.push(3);
  }

  if (!program.isThursday) {
    excludedDays.push(4);
  }

  if (!program.isFriday) {
    excludedDays.push(5);
  }

  if (!program.isSaturday) {
    excludedDays.push(6);
  }

  if (!program.isSunday) {
    excludedDays.push(0);
  }

  const dates = enumerateDaysBetweenDates(
    moment(program.startDate).toDate(),
    moment(program.endDate).toDate(),
    excludedDays
  );
  program.programSessionsDisplay = dates.map((d) => {
    return {
      id: nanoid(),
      date: moment(d).format("DD MMM YYYY (ddd)"),
      sessionDate: moment(d).toDate(),
      time:
        program.timeFrom && program.timeTo
          ? formatMomentTime(program.timeFrom) + " - " + formatMomentTime(program.timeTo)
          : "",
    };
  });
  items.value = program.programSessionsDisplay;
  showGenerateTimeTable.value = false;
};

const addDeliverer = () => {
  if (program.deliverers?.length == 6) {
    return;
  }

  program.deliverers?.push({
    tempId: generateTempId.value,
    name: "",
    delivererTypeId: 1,
    email: "",
  });
};

const removeDeliverer = (index: number) => {
  program.deliverers?.splice(index, 1);
};

const isValidDeliverer = (deliverer: IProgramDelivererVm) => {
  if (deliverer.delivererTypeId == DelivererTypeEnum.CommunityInstructor) {
    deliverer.isValidEmail = true;
    if (deliverer.email) {
      deliverer.isValidEmail = isEmail(deliverer.email);
    }
    return (
      deliverer.name &&
      deliverer.name != "" &&
      ((deliverer.email && deliverer.email != "") || deliverer.memberUID) &&
      deliverer.delivererTypeId
    );
  } else {
    deliverer.isValidEmail = true;
    return (
      deliverer.name &&
      deliverer.name != "" &&
      deliverer.membershipId &&
      deliverer.membershipId != "" &&
      deliverer.delivererTypeId
    );
  }
};

const isDelivererExists = async (deliverer: IProgramDelivererVm) => {
  setTimeout(async () => {
    delivererValidationStarted.value = true;
    if (!isValidDeliverer(deliverer)) {
      return;
    }
    if (isLoadingValidate.value) return
    if (deliverer.delivererTypeId == DelivererTypeEnum.CommunityInstructor) {
      const isAllAbilities = filteredProgramTypes.value.some(
        (x) => x.selected && x.programTypeId == ProgramTypeEnum.AllAbilities
      );
      const memberUID = await validateDeliverer(
        deliverer.name,
        deliverer.email,
        deliverer.delivererTypeId,
        isAllAbilities
      );

      deliverer.isValid = false;
      if (memberUID) {
        deliverer.isValid = true;
        deliverer.memberUID = memberUID;
      }
    } else {
      const isAllAbilities = filteredProgramTypes.value.some(
        (x) => x.selected && x.programTypeId == ProgramTypeEnum.AllAbilities
      );
      const memberUID = await validateDelivererByMembershipId(
        deliverer.name,
        deliverer.membershipId,
        deliverer.delivererTypeId,
        isAllAbilities
      );
      deliverer.isValid = false;
      if (memberUID) {
        deliverer.isValid = true;
        deliverer.memberUID = memberUID;
      }
    }
  }, 500)
};

const validateDeliverers = () => {
  program.deliverers?.forEach((x) => isDelivererExists(x));
};

const back = async () => {
  await router.push({
    name: "Participation",
    query: route.query,
  });
};

var programTermsWithLegacy = computed(() => {
  if (!isNew.value && isLegacyProgramTerm(program.programTermId)) {
      return programTerms.value && programTerms.value;
  }
  return programTerms.value && programTerms.value.filter(x => !x.isLegacy);
});

const isLegacyProgramTerm = (programTermId?: number | null | undefined) => {
  return programTerms.value && programTerms.value.some(x => x.programTermId == programTermId && x.isLegacy);
}

const saveProgramData = async () => {
  v$.value.$validate();
  validationStarted.value = true;

  var validDeliverers = program.deliverers &&
    program.deliverers.length > 0 &&
    program.deliverers.every(x => x.isValid);

  if(isClubhouseUser && isVirtualClub && clubId){
    program.createdByClubId = clubId.value;
  }

  if (isInValid.value || !validDeliverers || showGenerateTimeTable.value) {
    return;
  }

  if (program.timeFrom) {
    program.sessionTimeFrom = moment(program.timeFrom).format("HH:mm:ss");
  }

  if (program.timeTo) {
    program.sessionTimeTo = moment(program.timeTo).format("HH:mm:ss");
  }

  program.programSessions = program.programSessionsDisplay.map((d: any) => {
    return {
      sessionDate: moment.utc(d.date).toDate(),
    };
  });

  program.programTypesIds = programTypes.value
    .filter((x) => x.selected)
    .map((x) => x.programTypeId);
  program.programUID = isDuplicate.value ? null : program.programUID;

  if (!program.enabledDiscountForMultipleParticipants) {
    program.programCostSubsequentParticipant = null;
  }

  if (program.hasPriorityRegistration) {
    const priorityEndDate = moment(program.priorityRegistrationExpiryDate).utcOffset(0, true).format("YYYY-MM-DD");
    program.priorityRegistrationExpiryDate = priorityEndDate;    
    program.priorityRegistrationExpiryDateAdjustedOffset =`${priorityEndDate}T13:59:59Z`;
  }

  const startDateStr = moment(program.startDate).utcOffset(0, true).format("YYYY-MM-DD");
  program.startDate = startDateStr;

  const endDateStr = moment(program.endDate).utcOffset(0, true).format("YYYY-MM-DD");
  program.endDate = endDateStr;
  
  program.registrationCutOffDateUTCAdjustedOffset = convertToUTC(program.registrationCutOffDateUTC);
  
  const result = await saveProgram(program);

  if (result) {
    saveNotificationMessage?.value?.show();
    setTimeout(back, 500);
  }
};

const convertToUTC = (value) => {
  if (!value) return "";

  // Get the input date which is in local time of broswer
  const inputDate = new Date(value);
  // Set the time to the end of the day
  inputDate.setHours(23, 59, 59);
  // Finally convert to UTC
  const utcDate = zonedTimeToUtc(inputDate);

  return utcDate.toISOString();
}

</script>

<style scoped>
datalist option {
  color: red;
}

.hr {
  opacity: 0.03;
  border: 1px solid;
}

.form-check-input,
.form-check-label {
  cursor: pointer;
}

.checklabel {
  margin-left: 5px;
}

@media (max-width: 768px) {
  .aest {
    padding-top: 0 !important;
    margin-top: -15px;
  }
}

.aest {
  padding-top: 40px;
  font-weight: 500;
}

.time-picker-container {
  width: 90%;
}

.error {
  display: block;
  width: 100%;
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

.warning {
  margin-top: 5px;
  color: orangered;
  font-size: small;
}

.searchContainer {
  border-radius: var(--bs-border-radius);
  border: var(--bs-border-width) solid var(--bs-border-color);
  width: 100%;
}

.searchItem {
  display: block;
  cursor: pointer;
  width: 100%;
  padding: .375rem 2.25rem .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right .75rem center;
  background-size: 16px 12px;
  border: none;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  border-radius: var(--bs-border-radius);
}

.searchItem:hover {
  background-color: #1967D2;
  color: white
}
</style>
